<p-dialog
    appDialogoPadrao="pi pi-ban"
    descricao="Data e motivo do encerramento da autorização."
    [(visible)]="showDialog"
    [appendTo]="'body'"
    styleClass="telemedicina-dialog"
    header="Encerrar Telemedicina"
    [breakpoints]="{ '1100px': '35vw', '800px': '50vw', '500px': '95vw' }"
>
    <ng-template #content>
        <div class="mb-3 text-sm">
            Informe a Data Fim para o tipo: <strong>{{ tipo() }}</strong>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-12 gap-3">
            <div class="col-span-1 md:col-span-6">
                <label for="dataFim" class="block mb-2 font-semibold">Data Fim</label>
                <p-datepicker id="dataFim" [ngModel]="dataFim()" (ngModelChange)="dataFim.set($event)" dateFormat="dd/mm/yy" [iconDisplay]="'input'" [showIcon]="true" [appendTo]="'body'" class="w-full" />
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="flex justify-end gap-2 w-full">
            <p-button label="Cancelar" severity="secondary" (onClick)="onCancel()" />
            <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()" />
        </div>
    </ng-template>
</p-dialog>
